import { render } from "./BaseDialogFullscreenEditor.vue?vue&type=template&id=d6a74a04&scoped=true"
import script from "./BaseDialogFullscreenEditor.vue?vue&type=script&lang=js"
export * from "./BaseDialogFullscreenEditor.vue?vue&type=script&lang=js"

import "./BaseDialogFullscreenEditor.vue?vue&type=style&index=0&id=d6a74a04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a74a04"]])

export default __exports__